import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";

const ManageOrganization = () => {
  const [OrganizationListData, setOrganizationListData] = useState([]);
  const navigate = useNavigate();
   useEffect(() => {
    const fetchOrganizations = async () => {
      const token = localStorage.getItem('jwtToken');

      if (!token) {
        navigate("/");
        return;
      }

      try {
        const BASE_URL = window.BASE_URL + '/get_organizations_info';
        const config = {
          method: 'get',
          url: BASE_URL,
          headers: {
            'Authorization': 'Bearer ' + token,
          }
        };

        const response = await axios.request(config);

        if (response != null && response != undefined && response.data != null && response.data != undefined && response.data.results != null && response.data.results.length > 0) {
          setOrganizationListData(response.data.results);
        } else {
          setOrganizationListData([]);
        }
      } catch (error) {
        console.error("Error fetching organizations:", error);
      }
    };

    fetchOrganizations();
  }, [navigate]); 

  const fnCreateOrganizationClick = () => {
    navigate("/SuperAdmin/CreateOrganization");
  };
  return (
    <div className="container">
      <button
          className="btn btn-outline-secondary mb-3"
          onClick={() => navigate(-1)}>
           ← Back
         </button>
      <div className="form-outer">
        <div className="super-admin-header">
        
          <h1>Manage Organization</h1>
        </div>
        <div className="p-4">
          <h4 className="fw-bold my-3">List of Organizations</h4>
          <table className="table table-hover border">
            <thead className="table-secondary">
              <tr className="">
                <th>Name</th>
                <th>Mobile 1</th>
                <th>Mobile 2</th>
                <th>Email</th>
                <th>Address</th>
              </tr>
            </thead>
            <tbody>
              {OrganizationListData
                //.filter((value) => {
                // if (SubmissionType === "ALL" && SubmissionStatus === "ALL") {
                //     if (searchedVal) {
                //         return value.customer_name.toLowerCase().includes(searchedVal.toLowerCase());
                //     }
                //     return true;
                // }
                // else if (SubmissionType && SubmissionStatus === "ALL") {
                //     if (searchedVal) {
                //         return value.customer_name.toLowerCase().includes(searchedVal.toLowerCase());
                //     }
                //     return value.submition_type === SubmissionType;
                // }

                // else if (SubmissionStatus) {
                //     if (searchedVal) {
                //         return value.customer_name.toLowerCase().includes(searchedVal.toLowerCase());
                //     }
                //     return value.submission_status.toLowerCase() === SubmissionStatus.toLowerCase();
                // }
                // else {
                //     if (searchedVal) {
                //         return value.customer_name.toLowerCase().includes(searchedVal.toLowerCase());
                //     }
                //     return true;
                // }

                //})
                .map((Data, idx) => (
                  <tr 
                  key={idx}
                  className="cursor-pointer"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(`/SuperAdmin/organization/${Data.organization_id}`)}
                  >
                    <td>{Data.name}</td>
                    <td>{Data.mobile_1}</td>
                    <td>{Data.mobile_2}</td>
                    <td>{Data.email}</td>
                    <td>{Data.address_1 + ', ' + Data.address_2}</td>
                    {/* <td><Button variant="primary" onClick={() => handleShow(index)}>
                                            Details
                                        </Button></td> */}
                    {/*<td style={UserData.status_type === "APPROVED" ? { backgroundColor: 'green' } : UserData.status_type === "REJECTED" ? { backgroundColor: 'red' } : { backgroundColor: 'blue' } >{ UserData.status_type }</td>*/}
                  </tr>
                ))}
            </tbody>
          </table>
          <div className="text-center"><button className="super-admin-button" onClick={fnCreateOrganizationClick}>CREATE NEW ORGANIZATION</button></div>
        </div>
      </div>
    </div>
  );
};

export default ManageOrganization;